import { IEmployee } from '../../services/employees.service';

class TimesheetsSummaryController implements ng.IComponentController {
    summary: any;
    employees: IEmployee[];

    constructor() {
        'ngInject';
    }

    $onChanges = () => {
        // console.log('TimesheetsSummaryController')
        this.getCompletionData();
    }

    getCompletionData() {
        // console.log('getCompletionData')
        this.summary = {};
        this.summary.scheduledHours = 0;
        this.summary.scheduledShiftsCount = 0;
        this.summary.declaredHours = 0;
        this.summary.declaredShiftsCount = 0;
        this.summary.approvedHours = 0;
        this.summary.approvedShiftsCount = 0;
        this.summary.canceledShiftsCount = 0;
        this.summary.sickShiftsCount = 0;
        this.summary.canceledShiftsHours = 0;
        this.summary.sickShiftsHours = 0;

        this.employees.forEach(e => {
            e.approvedShiftCount = 0;
            e.approvedShiftHours = 0;
            e.declarationsApproved = true;

            e.doneShiftCount = e.shifts.filter(s => s.declarations.length > 0).length;

            e.shifts.forEach(s => {
                if (s.declarations.length > 0) {
                    this.summary.declaredShiftsCount++;                    
                    if (s.declarations.filter(d => d.status != 3).length == 0) {
                        e.approvedShiftCount++;
                    }
                }

                s.declarations.forEach(d => {
                    this.summary.declaredHours += d.duration;
                    if (d.status == 3) {
                        e.approvedShiftHours += d.duration;
                    } else {
                        e.declarationsApproved = false;
                    }
                });
            });

            this.summary.scheduledHours += e.shiftHours;
            this.summary.scheduledShiftsCount += e.shiftCount;
            this.summary.approvedHours += e.approvedShiftHours;
            this.summary.approvedShiftsCount += e.approvedShiftCount;
            this.summary.canceledShiftsCount += e.shiftCanceledCount;
            this.summary.sickShiftsCount += e.shiftSickCount;
            this.summary.canceledShiftsHours += e.shiftCanceledHours;
            this.summary.sickShiftsHours += e.shiftSickHours;

          
        });

        this.summary.scheduledHours = this.summary.scheduledHours.toFixed(2);
        this.summary.scheduledShiftsCount = this.summary.scheduledShiftsCount.toFixed(2);
        this.summary.declaredHours = this.summary.declaredHours.toFixed(2);
        this.summary.declaredShiftsCount = this.summary.declaredShiftsCount.toFixed(2);
        this.summary.approvedHours = this.summary.approvedHours.toFixed(2);
        this.summary.approvedShiftsCount = this.summary.approvedShiftsCount.toFixed(2);

        this.summary.canceledShiftsCount =  this.summary.canceledShiftsCount.toFixed(2);
        this.summary.sickShiftsCount = this.summary.sickShiftsCount.toFixed(2);
        this.summary.canceledShiftsHours = this.summary.canceledShiftsHours.toFixed(2);
        this.summary.sickShiftsHours =  this.summary.sickShiftsHours.toFixed(2);
    }
}

export const timesheetsSummaryComponent : ng.IComponentOptions = {
    controller: TimesheetsSummaryController,
    bindings: {
        employees: '<'
    },
    template: require('./timesheetsSummary.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/timesheets/timesheetsSummary.component.ts